import React, { useState, Fragment, useEffect } from 'react';
import { Tooltip } from "reactstrap";
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
    Row,
    Input,
    InputGroup,
    InputGroupAddon,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import moment from 'moment';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_Guests_By_Id, postAPI_Create_Guests, putAPI_Update_Guests, dAPI_Delete_Guests } from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
export function GuestForm({
    id,
    visible,
    toggleModal,
    formLabel,
    propertyId,
    LoadData
}) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };


    const [guestData, setGuestData] = useState({
        groupId: getGroupID(),
        propertyId: propertyId,
        firstName: '',
        lastName: '',
        roomNumber: 0,
        adults: 0,
        children: 0,
        checkInDate: '',
        checkOutDate: '',
        creator: 'dashboard'
    });

    useEffect(() => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Guests_By_Id}/${id}`,
            })
                .then(res => {
                    setGuestData(res.data)
                })
                .catch(err => console.log('err', err));
        }
    }, [id]);


    const handleChange = e => {
        setGuestData({
            ...guestData,
            [e.target.name]: e.target.value,
        });
    };

    const handleDelete = () => {
        AxiosAPI({
            method: 'delete',
            url: `${dAPI_Delete_Guests}/${id}`,
            data: {
                deleter: 'dashboard'
            },
        })
            .then(res => {
                toggle();
                LoadData();
            })
            .catch(err => {
                console.log(err);
            });
    };

    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This guest will be deleted!
                                </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Delete
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Cancel
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const handleSubmit = () => {

        if (id !== undefined) {

            AxiosAPI({
                method: 'put',
                url: `${putAPI_Update_Guests}/${id}`,
                data: guestData,
            })
                .then(res => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        toggleModal();
                        LoadData();
                    }
                }

                )
                .catch(err => {
                    console.log('err', err);
                });
        }
        else {

            AxiosAPI({
                method: 'post',
                url: `${postAPI_Create_Guests}`,
                data: guestData,
            })
                .then(res => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        toggleModal();
                        LoadData();
                    }

                }

                )
                .catch(err => {
                    console.log('err', err);
                });
        }
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggleModal} wrapClassName="modal-right"
                backdrop="static">
                <ModalHeader toggle={toggleModal}>{formLabel}</ModalHeader>
                {guestData != undefined && (
                    <ModalBody>
                        {/* <pre>{JSON.stringify(guestData, null, 2)}</pre> */}
                        <Label className="mt-3">
                            First Name
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={guestData.firstName}
                            name="firstName"
                            maxLength={50}
                        />
                        <Label className="mt-3">
                            Last Name
                        </Label>

                        <Input
                            type="text"
                            onChange={handleChange}
                            value={guestData.lastName}
                            name="lastName"
                            maxLength={50}
                        />
                        <Label className="mt-3">
                            Room Number
                        </Label>
                        <Input
                            type="text"
                            onChange={handleChange}
                            value={guestData.roomNumber}
                            name="roomNumber"
                            maxLength={50}
                        />

                        <Label className="mt-3">
                            Adults
                        </Label>
                        <Input
                            required
                            name="adults"
                            type="number"
                            min="0"
                            value={guestData.adults}
                            onChange={handleChange}
                        />

                        <Label className="mt-3">
                            Children
                        </Label>
                        <Input
                            required
                            name="children"
                            type="number"
                            min="0"
                            value={guestData.children}
                            onChange={handleChange}
                        />
                        <Label className="mt-3">
                            Check In Date
                        </Label>
                        <Input
                            required
                            type="date"
                            name="checkInDate"
                            value={moment(guestData.checkInDate).format('YYYY-MM-DD')}
                            onChange={handleChange}
                        />
                        <Label className="mt-3">
                            Check Out Date
                        </Label>
                        <Input
                            required
                            type="date"
                            name="checkOutDate"
                            value={moment(guestData.checkOutDate).format('YYYY-MM-DD')}
                            onChange={handleChange}
                        />
                        <Label className="mt-3">
                            Notes
                        </Label>

                        <Input
                            type="textarea"
                            onChange={handleChange}
                            value={guestData.notes}
                            name="notes"
                        />

                    </ModalBody>)}
                <ModalFooter>
                    <Button color="primary" onClick={handleSubmit}>
                        Save
                    </Button>
                    <Button color="secondary" onClick={toggleModal}>
                        Cancel
                    </Button>
                    {id && (<Button color="danger" onClick={toggle}>
                        Delete
                    </Button>)}

                </ModalFooter>
            </Modal>
            {generateDeleteButton()}
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment >
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(GuestForm));